// extracted by mini-css-extract-plugin
export default {"error":"ZR9Juuo-jxmOvLyMmbosnA==","liveRegion":"o49HydoDLExSRXzG-uP9Mg==","errorMessage":"hNaGKNXkcoT3Zj+TRBBrKg==","errorIcon":"Rxu-z40iSribJk5HCsfdug=="};